<script type="text/jsx">
import Icon from 'common/UIToolKit/Icon.vue';

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        value: {
            type: Boolean,
            default: null,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },

    render() {
        const data = (!this.readOnly) ? {
            class: { checked: this.value },
            on: {
                click: () => {
                    this.$emit('input', !this.value);
                    const ripple = this.$el.querySelector('.ripple');
                    ripple.classList.add('animate');
                    setTimeout(() => ripple.classList.remove('animate'), 600);
                },
            },
        } : { class: { 'read-only': true, 'checked': this.value } };

        const input = <input type="checkbox" class="absolute opacity-0 h-full w-full cursor-pointer"/>;
        if (this.id) {
            input.data.attrs.id = this.id;
        }

        return <div class="ui-checkbox" {...data}>
            <div class="ripple" />
            <div class="check">
                {
                    (this.value) ? <Icon for="checkbox" /> : ''
                }
            </div>
            {input}
        </div>;
    },
};
</script>

<style lang="scss">
    @import "common/scss/variables";
    @import "common/scss/palette";
    @import '@/styles/colors/variables';
    @import "common/scss/variables/v2/shadows";
    @import "common/scss/variables/curves";

    $checkbox-size: 16px;

    .ui-checkbox {
        @apply h-4 w-4 relative cursor-pointer text-elephant flex;
        &.read-only {
            @apply cursor-default;
        }

        .check {
            @apply h-4 w-4 relative bg-white border border-solid border-elephant rounded-sm ;
            color: inherit;
            overflow: hidden;
            transition: 0.3s all ease;

            .icon {
                top: -4px;
                left: -2px;
                position: absolute;
                font-size: 18px;
                overflow: hidden;
                pointer-events: none;
            }
        }

        &.checked:not(.read-only) {
            @apply text-leaf;
        }

        .ripple {
            @apply absolute h-4 w-4 bg-leaf rounded-full;
            transform: inherit;
            pointer-events: none;
            opacity: 0;

            &.animate {
                animation: scale-check-ripple 0.6s;
            }
        }

        @keyframes scale-check-ripple {
            0% {
                transform: inherit;
                transform: scale(1);
                opacity: 0.2;
            }
            30% {
                transform: inherit;
                transform: scale(2);
                opacity: 0.3;
            }
            100% {
                transform: inherit;
                transform: scale(0.2);
                opacity: 0;
            }
        }
    }

</style>
